import moment from "moment";
import BossModel from "@/models/BossModel";

export default class Deadline extends BossModel {
    /**
     *
     * @type {string}
     */
    static apiUrl = 'dossier/deadline';

    /**
     *
     * @type {string}
     */
    static entity = 'dossierDeadlines';

    static EXECUTE_ON = 1;
    static CALL_BACK_ON = 2;
    static SEND_PROPOSAL_ON = 3;

    static fields() {
        return {
            id: this.number(null).nullable(),
            deadline_type_cid: this.number(null).nullable(),
            dossier_id: this.number(null).nullable(),
            created_at: this.attr(null),
            date: this.attr(null),
            time: this.attr('17:30'),
            time_label: this.attr(null),
            daypart_cid: this.number(null).nullable(),
        }
    }

    label() {
        return moment(this.date).format('DD-MM-YYYY') + ' ' + this.time_label;
    }

    IsInFuture() {
        let today = moment();
        let exe = moment(this.date);

        return exe.isAfter(today, 'day');
    }

}
